import { setRecoil } from "recoil-nexus";

import { BetslipEventsEnum } from "src/constants/enums/betslipEvents";
import mainStore, { IMainStore } from "src/stores/main";
import { IEditingBet } from "src/constants/interfaces/bet";
import { decimalString } from "src/constants/types";
import { BetTypeEnum } from "src/constants/enums/betType";

const onSuperbetAccepted = () => {
  setRecoil(mainStore, (mainState: IMainStore) => ({
    ...mainState,
    isSuperbet: true,
    showSuccessState: true
  }));
};

const onClientIdle = () => {
  // const { verificationResponse } = getRecoil(mainStore);

  // if (verificationResponse?.success) {
  //     openDeferPopup<boolean>(VERIFICATION_LOGOUT_POPUP);
  // }
};

const onToggleEditMode = ({ bet }: { bet?: IEditingBet | null }) => {
  if (!bet) setRecoil(mainStore, (mainState) => ({ ...mainState, editingBet: null }));
  else {
    setRecoil(mainStore, (mainState) => ({
      ...mainState,
      betType: bet.betType,
      stake: bet.stake.toString() as decimalString || mainState.stake,
      systemCombinationCount: bet.systemCombinationCount || mainState.systemCombinationCount,
      editingBet: bet,
    }));
  }
};

const onChangeBetType = ({ betType }: { betType: BetTypeEnum }) => {
  setRecoil(mainStore, (mainState) => ({ ...mainState, betType }));
}

export const listenersMap = {
  [BetslipEventsEnum.SuperbetAccepted]: onSuperbetAccepted,
  [BetslipEventsEnum.ClientIdle]: onClientIdle,
  [BetslipEventsEnum.ToggleEditMode]: onToggleEditMode,
  [BetslipEventsEnum.ChangeBetType]: onChangeBetType,
};
